import { render, staticRenderFns } from "./bar-percentage-chart.html?vue&type=template&id=41f84f40&scoped=true&"
import script from "./bar-percentage-chart.ts?vue&type=script&lang=js&"
export * from "./bar-percentage-chart.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f84f40",
  null
  
)

export default component.exports